import * as Yup from 'yup'

export const SignInSchema = Yup.object().shape({
    email: Yup.string()
        .email()
        .trim('Spaces not allowed')
        .strict()
        .required('Email is required'),
    password: Yup.string().trim('Spaces not allowed').required().strict(),
})
